<template>
    <UserEdit
        :showEditInfo="showEditInfo"
        @showModalEditDataUser="handleShowModalEditDataUser"
    />
    <header
        class="global_header weeducStudentHeader"
        :class="{ dark: dark, 'weeducStudentHeader--course': courseSidebarMenu }"
    >
        <div
            class="weeduc-header__inner"
            :class="{ 'weeduc-header__inner--course-desktop': courseSidebarMenu }"
        >
            <div v-if="!courseSidebarMenu" class="weeduc-header__brand logo">
                <router-link to="/aluno">
                    <img
                        v-show="!dark"
                        src="../../../../../src/assets/logo.png"
                        :alt="$t('student.header.homeAlt')"
                    />
                    <img
                        v-show="dark"
                        src="../../../../../src/assets/logo_white.png"
                        :alt="$t('student.header.homeAlt')"
                    />
                </router-link>
            </div>
            <div
                v-else
                class="weeduc-header__brand weeduc-header__brand--course-menu"
            >
                <button
                    type="button"
                    class="icon-button weeduc-header__toolbar-menu-btn weeduc-header__lessons-btn"
                    :aria-label="showSidebar ? $t('student.header.closeLessons') : $t('student.header.openLessons')"
                    :aria-expanded="Boolean(showSidebar)"
                    aria-controls="course-lessons-drawer"
                    @click="toggleLessonsSidebar"
                >
                    <fa icon="bars" />
                </button>
            </div>

            <nav
                class="weeduc-header__nav menu item"
                :aria-label="$t('student.header.mainNav')"
            >
                <ul>
                    <li :class="{ active: navActiveIndex === 0 }">
                        <router-link
                            to="/aluno"
                            class="itemMenuPortalAluno"
                            active-class=""
                            exact-active-class=""
                        >
                            {{ $t('student.header.home') }}
                        </router-link>
                    </li>
                    <li
                        v-if="isCoursePlayerRoute"
                        :class="{ active: navActiveIndex === 5 }"
                    >
                        <router-link
                            :to="coursePlayerPath"
                            class="itemMenuPortalAluno"
                            active-class=""
                            exact-active-class=""
                        >
                            {{ $t('student.header.course') }}
                        </router-link>
                    </li>
                    <li
                        v-if="dataWebsitePortal2?.showInquiry == 1"
                        :class="{ active: navActiveIndex === 1 }"
                    >
                        <router-link
                            to="/aluno/duvidas"
                            class="itemMenuPortalAluno"
                        >
                            {{ $t('student.header.myDoubts') }}
                        </router-link>
                    </li>
                    <li
                        v-if="dataWebsitePortal2?.showForum == 1"
                        :class="{ active: navActiveIndex === 2 }"
                    >
                        <router-link
                            to="/aluno/forum"
                            class="itemMenuPortalAluno"
                        >
                            {{ $t('student.header.forums') }}
                        </router-link>
                    </li>
                    <li
                        v-if="dataWebsitePortal2?.showCertificate == 1"
                        :class="{ active: navActiveIndex === 3 }"
                    >
                        <router-link
                            to="/aluno/certificados"
                            class="itemMenuPortalAluno"
                        >
                            {{ $t('student.header.certificates') }}
                        </router-link>
                    </li>
                    <li
                        v-if="canAccessMonitoring"
                        :class="{ active: navActiveIndex === 6 }"
                    >
                        <router-link
                            to="/aluno/acompanhamento"
                            class="itemMenuPortalAluno"
                        >
                            {{ $t('student.header.monitoring') }}
                        </router-link>
                    </li>
                    <li v-if="typeId == 2" :class="{ active: navActiveIndex === 4 }">
                        <router-link
                            to="/dashboard/painel"
                            class="itemMenuPortalAluno"
                        >
                            {{ $t('student.header.adminPanel') }}
                        </router-link>
                    </li>
                </ul>
            </nav>

            <div class="weeduc-header__toolbar menu icone_actions">
                <ul>
                    <li
                        v-if="!courseSidebarMenu"
                        class="weeduc-header__toolbar-menu-item"
                    >
                        <button
                            type="button"
                            class="icon-button weeduc-header__toolbar-menu-btn menu_mobile"
                            :aria-label="showMenuMobile ? $t('student.header.closeMainMenu') : $t('student.header.openMainMenu')"
                            :aria-expanded="showMenuMobile"
                            aria-controls="student-portal-mobile-menu"
                            @click="togglePortalMenu"
                        >
                            <fa icon="bars" />
                        </button>
                    </li>
                    <li
                        v-if="showNotifications"
                        class="notification-item"
                        style="position: relative"
                    >
                        <button
                            type="button"
                            class="icon-button"
                            :aria-label="qtdnotification > 0 ? $t('student.header.unreadNotifications', { n: qtdnotification > 99 ? '99+' : qtdnotification }) : $t('student.header.notifications')"
                            :aria-expanded="hasNotification"
                            @click.stop="showNotification"
                        >
                            <fa icon="fa-bell" />
                            <span
                                v-if="qtdnotification > 0"
                                class="qtd_notification"
                                :aria-label="$t('student.header.unreadCount')"
                            >{{
                                qtdnotification > 99 ? '99+' : qtdnotification
                            }}</span>
                        </button>
                        <div
                            ref="notificationContainer"
                            class="notification_bar"
                            :class="{ show: hasNotification, dark: dark }"
                        >
                            <Notification
                                :data="data"
                                :title="$t('student.notifications.title')"
                                @unread-count-updated="updateNotificationCount"
                            />
                        </div>
                    </li>

                    <li>
                        <button
                            type="button"
                            class="icon-button"
                            :aria-label="dark ? $t('toolbar.toggleLight') : $t('toolbar.toggleDark')"
                            @click="changeViewMode()"
                        >
                            <span v-if="dark"><fa icon="sun" /></span>
                            <span v-else><fa icon="moon" /></span>
                        </button>
                    </li>

                    <li>
                        <button
                            type="button"
                            class="icon-button avatar-button"
                            :aria-label="$t('student.header.viewProfile')"
                            @click="() => $router.push('/aluno/perfil')"
                        >
                            <span class="logo_name">{{ name }}</span>
                        </button>
                    </li>

                    <li>
                        <button
                            type="button"
                            class="icon-button"
                            :aria-label="$t('student.header.logout')"
                            @click="logout"
                        >
                            <fa icon="fa-power-off" />
                        </button>
                    </li>
                </ul>
            </div>
        </div>

        <!-- Header mobile exclusivo da página do curso -->
        <div
            v-if="courseSidebarMenu"
            class="weeduc-course-mobile-header"
        >
            <div class="weeduc-course-mobile-header__main">
                <button
                    type="button"
                    class="weeduc-course-mobile-header__lessons"
                    :class="{ 'is-open': Boolean(showSidebar) }"
                    :aria-label="showSidebar ? $t('student.header.closeLessons') : $t('student.header.openLessons')"
                    :aria-expanded="Boolean(showSidebar)"
                    aria-controls="course-lessons-drawer"
                    @click="toggleLessonsSidebar"
                >
                    <v-icon size="18" aria-hidden="true">mdi-format-list-bulleted</v-icon>
                    <span>{{ $t('student.header.lessons') }}</span>
                </button>

                <p
                    class="weeduc-course-mobile-header__position"
                    :title="courseLessonPositionFull || undefined"
                    :aria-label="courseLessonPositionFull || undefined"
                >
                    <span class="weeduc-course-mobile-header__position-full">
                        {{ courseLessonPositionShort }}
                    </span>
                    <span
                        class="weeduc-course-mobile-header__position-compact"
                        aria-hidden="true"
                    >
                        {{ courseLessonPositionCompact }}
                    </span>
                </p>

                <button
                    type="button"
                    class="weeduc-course-mobile-header__more"
                    :aria-label="showMenuMobile ? $t('student.header.closeMainMenu') : $t('student.header.openMainMenu')"
                    :aria-expanded="showMenuMobile"
                    aria-controls="student-portal-mobile-menu"
                    @click="togglePortalMenu"
                >
                    <v-icon size="22" aria-hidden="true">mdi-dots-vertical</v-icon>
                </button>
            </div>

            <div
                v-if="courseLessonTitle || courseModuleTitle || courseProgressPercent != null"
                class="weeduc-course-mobile-context"
            >
                <strong
                    v-if="courseLessonTitle"
                    class="weeduc-course-mobile-context__lesson"
                    :title="courseLessonTitle"
                >
                    {{ courseLessonTitle }}
                </strong>
                <div
                    v-if="courseModuleTitle || courseProgressPercent != null"
                    class="weeduc-course-mobile-context__meta"
                >
                    <span v-if="courseModuleTitle">{{ courseModuleTitle }}</span>
                    <span v-if="courseProgressPercent != null">
                        {{ $t('student.header.courseProgressPercent', { percent: courseProgressPercent }) }}
                    </span>
                </div>
                <div
                    v-if="courseProgressPercent != null"
                    class="weeduc-course-mobile-context__progress"
                    role="progressbar"
                    :aria-valuenow="courseProgressPercent"
                    aria-valuemin="0"
                    aria-valuemax="100"
                    :aria-label="$t('student.header.courseProgressLabel')"
                >
                    <div
                        class="weeduc-course-mobile-context__progress-fill"
                        :style="{ width: `${courseProgressPercent}%` }"
                    />
                </div>
            </div>
        </div>
    </header>

    <MobileMenu
        :showMenuMobile="showMenuMobile"
        @fechar-menu-header="closeMenu"
        @logout="logout"
    />
</template>

<script>
    import UserEdit from '@/components/Student/Dashboard_Unique/Info_User/user.vue';
    import Notification from './Notifications.vue';
    import { mapState, mapActions } from 'vuex';
    import api from '@/utils/portal/notification.js';
    import MobileMenu from './mobileMenu.vue';
    import { canAccessTeamMonitoring } from '@/utils/corporate/users';

    export default {
        props: {
            /**
             * Na página do curso o primeiro ícone abre a lista de módulos/aulas
             * em vez do menu mobile do dashboard.
             */
            courseSidebarMenu: {
                type: Boolean,
                default: false,
            },
            /** Módulos/aulas do curso (para posição e contexto no header mobile). */
            courseModules: {
                type: Array,
                default: null,
            },
        },
        data() {
            return {
                showEditInfo: false,
                hasNotification: false,
                qtdnotification: 0,
                data: [],
                showNavItem: false,
                name: null,
                fullName: null,
                showMenuMobile: false,
                userLoaded: false,
                notificationsLoaded: false,
            };
        },

        components: {
            Notification,
            UserEdit,
            MobileMenu,
        },

        computed: {
            ...mapState([
                'token',
                'typeId',
                'user',
                'dark',
                'showSidebar',
                'idLessonPortal',
                'nameCurrentLesson',
                'porcetageProgressCurrentCourse',
            ]),
            ...mapState('portal', ['dataWebsitePortal2']),
            showNotifications() {
                return this.dataWebsitePortal2?.showNotification != 0;
            },
            canAccessMonitoring() {
                return canAccessTeamMonitoring(this.user);
            },
            /**
             * Índice do item ativo derivado da rota (evita "Início" preso em 0 só por estado local).
             * -1 = nenhum item da barra principal.
             */
            navActiveIndex() {
                const path = this.$route.path;

                if (path.startsWith('/aluno/curso/')) {
                    return 5;
                }

                if (path.startsWith('/dashboard/painel')) {
                    return 4;
                }

                if (path.startsWith('/aluno/duvidas')) {
                    return 1;
                }
                if (path.startsWith('/aluno/forum')) {
                    return 2;
                }
                if (
                    path.startsWith('/aluno/certificados') ||
                    /^\/aluno\/certificado\//.test(path)
                ) {
                    return 3;
                }

                if (
                    path === '/aluno/acompanhamento'
                    || path.startsWith('/aluno/acompanhamento/')
                ) {
                    return 6;
                }

                if (
                    path === '/aluno' ||
                    path === '/aluno/' ||
                    path.startsWith('/aluno/dashboard')
                ) {
                    return 0;
                }

                return -1;
            },
            isCoursePlayerRoute() {
                return this.$route.path.startsWith('/aluno/curso/');
            },
            coursePlayerPath() {
                const slug = this.$route.params.slug;
                return slug ? `/aluno/curso/${slug}` : '/aluno/dashboard';
            },
            flattenedCourseLessons() {
                if (!Array.isArray(this.courseModules)) return [];
                const out = [];
                this.courseModules.forEach((mod) => {
                    if (!mod || !Array.isArray(mod.lessons)) return;
                    mod.lessons.forEach((lesson) => {
                        if (lesson && lesson.id != null) {
                            out.push({ lesson, module: mod });
                        }
                    });
                });
                return out;
            },
            courseTotalLessons() {
                return this.flattenedCourseLessons.length;
            },
            courseCurrentLessonIndex() {
                const id = this.idLessonPortal;
                if (id == null) return -1;
                return this.flattenedCourseLessons.findIndex(
                    (e) => String(e.lesson.id) === String(id),
                );
            },
            courseCurrentLessonEntry() {
                const idx = this.courseCurrentLessonIndex;
                if (idx < 0) return null;
                return this.flattenedCourseLessons[idx];
            },
            courseLessonPositionFull() {
                if (this.courseCurrentLessonIndex < 0) return '';
                const n = this.courseCurrentLessonIndex + 1;
                if (this.courseTotalLessons > 0) {
                    return this.$t('student.header.lessonOfTotal', { n, total: this.courseTotalLessons });
                }
                return this.$t('student.header.lessonN', { n });
            },
            courseLessonPositionShort() {
                return this.courseLessonPositionFull;
            },
            courseLessonPositionCompact() {
                if (this.courseCurrentLessonIndex < 0) return '';
                const n = this.courseCurrentLessonIndex + 1;
                if (this.courseTotalLessons > 0) {
                    return this.$t('student.header.positionCompact', { n, total: this.courseTotalLessons });
                }
                return String(n);
            },
            courseLessonTitle() {
                return (
                    this.nameCurrentLesson
                    || this.courseCurrentLessonEntry?.lesson?.title
                    || ''
                );
            },
            courseModuleTitle() {
                return this.courseCurrentLessonEntry?.module?.title || '';
            },
            courseProgressPercent() {
                const raw = this.porcetageProgressCurrentCourse;
                if (raw == null || raw === '') return null;
                const n = typeof raw === 'number' ? raw : parseFloat(raw);
                if (Number.isNaN(n)) return null;
                return Math.min(100, Math.max(0, Math.round(n)));
            },
        },

        watch: {
            user: {
                handler(newVal) {
                    if (newVal && newVal.name) {
                        this.loadDataUser();
                        this.userLoaded = true;
                    }
                },
                immediate: true,
                deep: true,
            },
            token(newVal) {
                if (newVal) {
                    this.loadNotifications();
                }
            },
            dataWebsitePortal2: {
                handler(website) {
                    if (website && website.showNotification == 0) {
                        this.data = [];
                        this.qtdnotification = 0;
                        this.hasNotification = false;
                        return;
                    }
                    if (website && this.token) {
                        this.loadNotifications();
                    }
                },
                immediate: true,
            },
            showMenuMobile(val) {
                if (val) {
                    document.body.style.overflow = 'hidden';
                    return;
                }
                if (this.courseSidebarMenu && this.showSidebar) {
                    document.body.style.overflow = 'hidden';
                    return;
                }
                document.body.style.overflow = '';
            },
        },

        methods: {
            ...mapActions([
                'toggleDarkMode',
                'storeShowSidebar',
            ]),

            toggleLessonsSidebar() {
                const next = !this.$store.state.showSidebar;
                if (next) {
                    this.showMenuMobile = false;
                }
                this.storeShowSidebar({ showSidebar: next });
            },

            togglePortalMenu() {
                const next = !this.showMenuMobile;
                if (next && this.courseSidebarMenu) {
                    this.storeShowSidebar({ showSidebar: false });
                }
                this.showMenuMobile = next;
            },

            onMenuTriggerClick() {
                if (this.courseSidebarMenu) {
                    this.toggleLessonsSidebar();
                    return;
                }
                this.togglePortalMenu();
            },

            async loadDataUser() {
                if (this.user && this.user.name) {
                    this.fullName = this.user.name;
                    this.name = this.user.name.substring(0, 2);
                } else {
                    this.fullName = '';
                    this.name = '';
                }
            },

            loadNotifications() {
                if (this.dataWebsitePortal2?.showNotification == 0) return;
                if (this.notificationsLoaded || !this.token) return;
                this.notificationsLoaded = true;
                this.getDataNotification();
                this.getNumberNitification();
            },

            async getDataNotification() {
                try {
                    const response = await api.getDataNotifications(this.token);
                    this.data = response;
                } catch (error) {
                    console.error('Erro na listagem das notificações:', error);
                }
            },

            async getNumberNitification() {
                try {
                    const response = await api.getNumberNotifications(
                        this.token
                    );
                    this.qtdnotification = response;
                } catch (error) {
                    console.error('Erro ao buscar número de notificações:', error);
                }
            },

            updateNotificationCount(count) {
                this.qtdnotification = count;
            },

            logout() {
                this.$store.dispatch('logout');
                localStorage.removeItem('vuex');
                localStorage.removeItem('activeIndex');
                localStorage.removeItem('logado');
                window.location.href = '/portal';
            },

            handleShowModalEditDataUser(showEditInfo) {
                this.showEditInfo = showEditInfo;
            },

            changeViewMode() {
                this.toggleDarkMode({ dark: !this.dark });
            },

            showNotification() {
                this.hasNotification = !this.hasNotification;
            },

            closeMenu() {
                this.showMenuMobile = false;
            },

            onGlobalKeydown(event) {
                if (event.key === 'Escape' && this.showMenuMobile) {
                    this.closeMenu();
                }
            },

            handleClickOutside(event) {
                const clickedOutsideNotification =
                    this.$refs.notificationContainer &&
                    !this.$refs.notificationContainer.contains(event.target);

                if (clickedOutsideNotification) {
                    this.hasNotification = false;
                }
            },
        },

        mounted() {
            document.addEventListener('click', this.handleClickOutside);
            window.addEventListener('keydown', this.onGlobalKeydown);

            this.loadNotifications();

            if (this.user && this.user.name) {
                this.loadDataUser();
                this.userLoaded = true;
            }
        },

        beforeUnmount() {
            document.removeEventListener('click', this.handleClickOutside);
            window.removeEventListener('keydown', this.onGlobalKeydown);
            if (this.showMenuMobile) {
                document.body.style.overflow = '';
            }
        },
    };
</script>

<style scoped>
    @import url(./index.css);
</style>
